import styled from 'styled-components';

const InputContainer = styled.div`
  min-height: 60px;
  
  /* Style child input elements */
  input {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export default InputContainer;
